import _Vue from "vue";
import regexes from "@/util/regexes";

export function Regexes(Vue: typeof _Vue): void {
    Vue.prototype.$regexes = regexes;
}
